import React, { Component } from "react";
import "./item-contact.scss";
import ItemWithText from "../ItemWithText";
import anime from "animejs";
import MenuAuxiliary from "../MenuAuxiliaxy";

export default class ItemContact extends Component {
  constructor(props) {
    super(props);
    this.isFirstTime = props.firstTime;
  }

  componentDidMount() {
    if (this.isFirstTime) {
      anime({
        targets: [".itm1-col2-rw2"],
        translateX: ["-13rem", "0rem"],
        translatY: ["13rem", "0rem"],
        rotateY: "1turn",
        scale: [0, 1],
        borderRadius: "8px",
        duration: 16363,
        loop: false,
      });
      anime({
        targets: [".itm1-col2-rw1"],
        translateX: ["13rem", "0rem"],
        scale: [0, 1],
        borderRadius: "8px",
        duration: 16363,
        loop: false,
      });
      anime({
        targets: [".cnt-col2-row1-2"],
        translateX: ["13rem", "0rem"],
        scale: [0, 1],
        borderRadius: "8px",
        duration: 16363,
        loop: false,
      });
    }
  }

  render() {
    if (this.props.type) {
      return (
        <div className={`cnt-col2-row1 ${"f-exp"}`}>
          <div className={"cnt-col2-row1-1"}>
            <div className={"itm1-col2-rw1 f-exp ai-st jc-c zi-1 jc-s"}>
              <a href={"#/"} className={"ai-c jc-s d-fl hei-3-5 ta-c"}>
                <span className={"fs-21 fw-b ta-c"}> Go </span>
                <div
                  className={"si-2 lg-icon"}
                  style={{
                    webkitMaskImage:
                      "url(" +
                      require("../../rsc/assets/rowRight.svg").default +
                      ")",
                  }}
                />
              </a>
              <MenuAuxiliary />
            </div>
          </div>
          <div className={"cnt-col2-row1-2"}>
            <div className={"sel-mod-image"}> {this.props.widgetMain} </div>
          </div>
          <div className="cnt-col2-row1-3">
            <div className={"body-col3"}>
              <a href="#/about">
              <h2 className={"fs-22 ta-c"}>TECHNOLOGICAL SOLUTIONS</h2>
              </a>
              <div className={"ct-items-contact"}>
                <ItemWithText
                  title={"Linkedin"}
                  path={"https://www.linkedin.com/in/cristiangaviria/"}
                  imgItem={require("../../rsc/assets/linkedin.svg")}
                />
                <ItemWithText
                  title={"Email"}
                  path={"mailto:cristian@gaviria.org"}
                  imgItem={require("../../rsc/assets/email.svg")}
                />
                <ItemWithText
                  title={"Call"}
                  path={"tel:573508010429"}
                  imgItem={require("../../rsc/assets/call.svg")}
                />
              </div>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className={"cnt-col2-row1"}>
        <div className={"cnt-col2-row1-1"}>
          <div className={"itm1-col2-rw1 ai-c"}>
            <img
              className={"img-medal-new"}
              src={require("../../rsc/assets/medalNew.svg").default}
              alt=""
            />
            <span className={"fs-17 fw-b"}>
              <span>
                Gaviria IT Software Services - 
                &nbsp;<small>Belong to the <span className={"col-purp1"}>purple</span>{" "}
                team</small>
              </span>
            </span>
          </div>
        </div>
        <div className={"cnt-col2-row1-2"}>
          <img
            className={"sel-mod-image"}
            src={require("../../rsc/assets/profile.png").default}
            width="17em"
            height="17em"
            alt=""
          />
        </div>
      </div>
    );
  }
}
